import { useEffect } from "react"
import parse from "html-react-parser"
import classnames from "classnames"

import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import styles from "./diy_add_tanda_button.module.scss"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button"
import PlusIcon from "shared/components/icons/plus_icon"
import { hasProPlusFeatures, planNameBadge } from "shared/utils/tiers"

interface Props {
  delayAdded: boolean
  filterCodeAdded: boolean
  onDelayButtonClick: () => void
  onFilterButtonClick: () => void
  onQueryButtonClick: () => void
  userTier: string
}

export default function DIYAddFilterQueryButtons({
  delayAdded,
  filterCodeAdded,
  onDelayButtonClick,
  onFilterButtonClick,
  onQueryButtonClick,
  userTier,
}: Props) {
  useEffect(() => {
    attachNewBadgeForButtons()
  }, [])

  return (
    <section className={styles["add-new-query-filter-delay"]}>
      <div className={styles["add-query"]} onClick={verifyIntendedPromiseRejection(onQueryButtonClick)}>
        <div className="description">
          <div className={styles.title}>
            <h4 className="h4">Query</h4>
            {!hasProPlusFeatures(userTier) && (
              <span className={classnames(styles.badge, styles.pro_plus)}>{parse(planNameBadge("Pro+"))}</span>
            )}
            <span className={styles.badge} data-allow-new-badge="queries" />
          </div>
          <p className="txt-body-3">Get additional data from triggers</p>
        </div>
        <button className={classnames("plus-icon-button", styles.add)}>
          <PlusIcon />
        </button>
      </div>
      {filterCodeAdded ? (
        <></>
      ) : (
        <div className={styles["add-filter"]} onClick={verifyIntendedPromiseRejection(onFilterButtonClick)}>
          <div className="description">
            <div className={styles.title}>
              <h4 className="h4">Filter code</h4>
              {!hasProPlusFeatures(userTier) && (
                <span className={classnames(styles.badge, styles.pro_plus)}>{parse(planNameBadge("Pro+"))}</span>
              )}
              <span className={styles.badge} data-allow-new-badge="filter_code" />
            </div>
            <p className="txt-body-3">Add the power of JavaScript logic</p>
          </div>
          <button className={classnames("plus-icon-button", styles.add)}>
            <PlusIcon />
          </button>
        </div>
      )}
      {delayAdded ? (
        <></>
      ) : (
        <>
          <div className={styles["add-delay"]} onClick={verifyIntendedPromiseRejection(onDelayButtonClick)}>
            <div className="description">
              <div className={styles.title}>
                <h4 className="h4">Delay</h4>
                <span className={styles.badge} />
              </div>
              <p className="txt-body-3">Add a delay to the next action</p>
            </div>
            <button className={classnames("plus-icon-button", styles.add)}>
              <PlusIcon />
            </button>
          </div>
        </>
      )}
    </section>
  )
}
